import { CarMileageEntry, HistoryEntry, Visit } from '../../models';
import { APPEND_HISTORY_ENTRIES, GET_HISTORY_ENTRIES } from '../constants/historyEntriesList';

/* eslint-disable camelcase */
// eslint-disable-next-line import/prefer-default-export
export const getHistoryEntries = (response) => {
  const { count, limit, offset, next, previous, results: historyEntries } = response ?? {};

  const convertedHistoryEntries = historyEntries.map((data) => {
    const { id, visit, mileage } = data;

    const visitDetail = visit
      ? new Visit(
          visit.id,
          null,
          null,
          visit?.scheduled_time,
          visit?.message_from_client,
          visit?.message_from_workshop,
        )
      : null;

    const mileageEntry = mileage
      ? new CarMileageEntry(mileage.id, mileage.mileage_in_kilometers)
      : null;

    return new HistoryEntry(id, visitDetail, mileageEntry);
  });

  return (dispatch) => {
    dispatch({
      type: GET_HISTORY_ENTRIES,
      historyEntries: convertedHistoryEntries,
      count,
      limit,
      offset,
      next,
      previous,
    });
  };
};

export const appendHistoryEntries = (response) => {
  const { count, limit, offset, next, previous, results: historyEntries } = response ?? {};

  const convertedHistoryEntries = historyEntries.map((data) => {
    const { id, visit, mileage } = data;

    const visitDetail = visit
      ? new Visit(
          visit.id,
          null,
          null,
          visit?.scheduled_time,
          visit?.message_from_client,
          visit?.message_from_workshop,
        )
      : null;

    const mileageEntry = mileage
      ? new CarMileageEntry(mileage.id, mileage.mileage_in_kilometers)
      : null;

    return new HistoryEntry(id, visitDetail, mileageEntry);
  });

  return (dispatch) => {
    dispatch({
      type: APPEND_HISTORY_ENTRIES,
      historyEntries: convertedHistoryEntries,
      count,
      limit,
      offset,
      next,
      previous,
    });
  };
};
